// src/components/ResultsPanel.js
import { useState, useMemo, useEffect, useRef } from "react";
import { Card, Button, Spinner, Nav, Badge} from "react-bootstrap";
import { saveToHistory } from "../utils/estimates";
import { queryOpenAI } from "../services/openai";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";

import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase"; // adjust path if needed
// import { useAuth } from "../contexts/AuthContext"; // if you use your auth context
import { signInWithGoogle } from "../firebase";
// import { InboxFill } from "react-bootstrap-icons"; // add this at the top
import "../styles/resultpanel.css";

import mixpanel from 'mixpanel-browser';
// import { color } from "framer-motion";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { Download } from "react-bootstrap-icons";

mixpanel.init("2ab96ecad7451ea49cebc5f84b528f7c");


export default function ResultsPanel({ key, responseRaw, onDrill, loading, error, queryMeta, userId, aboutClicked, setAboutClicked, resultsResetTrigger}) {
  let parsed = null;
  const [sectionMode, setSectionMode] = useState("visual"); 
  const [visMode, setVisMode] = useState("excellentAt"); // "withTrait" | "goodAt" | "excellentAt"

    // mini-traits state
  const [miniTraits, setMiniTraits] = useState(null); // array of { trait, why, score }
  const [miniLoading, setMiniLoading] = useState(false);
  const [miniError, setMiniError] = useState(null);

  // Track number of offerings and thank-you state
  const [offerCount, setOfferCount] = useState(0);
  const [thankYou, setThankYou] = useState(false);

  // const [dots, setDots] = useState([]);

  const [showSavedModal, setShowSavedModal] = useState(false);
  const [showSignInModal, setShowSignInModal] = useState(false);

  const [visibleCount, setVisibleCount] = useState(0);



  const [done, setDone] = useState(false); // track if we've scrolled to results


  //  const [aboutClicked, setAboutClicked] = useState(() => {
  //   // Check local storage if user has opened About Result before
  //   return localStorage.getItem("aboutResultOpened") === "false";
  // });

  // diary
  const poolKey = parsed?.traitRemix || queryMeta?.query || "unknown";
  const todayKey = `diary-${dayjs().format("YYYY-MM-DD")}-${poolKey}`;
  // const [diaryAnswer, setDiaryAnswer] = useState(
  //   localStorage.getItem(todayKey) || ""
  // );
  const rawStored = localStorage.getItem(todayKey);
  let initialDiary = "";

  const MIN_THOUGHTS = 1000000;        // 1 million
  const MAX_THOUGHTS = 100000000000; // 100 billion

  const revealStarted = useRef(false);

  // battery
  const [energyCharge, setEnergyCharge] = useState(5); // 0,25,50,75,100
  const HOLD_FULL_MS = 1 * 60 * 1000; // 1 minutes = 60,000ms

// Hold / charge tracking
  const [holdTimeMs, setHoldTimeMs] = useState(0); // milliseconds
  const [isHolding, setIsHolding] = useState(false);

  const holdStartRef = useRef(null);
  const holdIntervalRef = useRef(null);


  const speechUnlockedRef = useRef(false);

  const voicesReadyRef = useRef(false);
  const cachedVoiceRef = useRef(null);
  const [perspectiveSelection, setPerspectiveSelection] = useState(0.35); // initial random perspective. 0.4
 const [baseSpacing, setBaseSpacing] = useState(1); // initial base spacing between rings



 function ensureVoicesReady() {
  const voices = window.speechSynthesis.getVoices();

  if (voices.length > 0) {
    cachedVoiceRef.current =
      voices.find(v => v.lang.startsWith("en-US")) || voices[0];
    voicesReadyRef.current = true;
    return true;
  }

  return false;
}


// function unlockSpeechOnce() {
//   if (speechUnlockedRef.current) return;

//   const u = new SpeechSynthesisUtterance(" ");
//   window.speechSynthesis.speak(u);
//   speechUnlockedRef.current = true;
// }


function startHold() {
   // 🔓 MUST be first, before any state change
  if (!voicesReadyRef.current) {
    ensureVoicesReady();
    return; // first tap ONLY unlocks voices
  }
  speakEncouragement();
  if (isHolding) return;

  setIsHolding(true);
  holdStartRef.current = Date.now();

  holdIntervalRef.current = setInterval(() => {
    const elapsed = Date.now() - holdStartRef.current;
    setHoldTimeMs(elapsed);

    const percent = Math.min(
      100,
      (elapsed / HOLD_FULL_MS) * 100
    );

    setEnergyCharge(Math.round(percent));
  }, 100);
}

function endHold() {
  if (!isHolding) return;

  setIsHolding(false);
  window.speechSynthesis.cancel();
  clearInterval(holdIntervalRef.current);
  holdIntervalRef.current = null;
}


async function handlePrintAncestralPool() {
      const pdf = new jsPDF("portrait", "mm", "a4");

      /* ---------- PAGE 1: ABOUT ---------- */
      pdf.setFont("helvetica", "normal");

      pdf.setFontSize(18);
      pdf.text(`${parsed?.traitRemix || ""}`, 20, 30);

       pdf.setFontSize(10);
       pdf.setTextColor(120);
       pdf.text(
            `Top 1% Ancestors: ${parsed?.[visMode]?.toLocaleString() || ""} Ancestors`,
            20,
            40
          );
      pdf.text(
            `Total Ancestors: ${parsed?.totalAncestors?.toLocaleString() || "15,000,000,000"} Ancestors`,
            20,
            45
          );
      pdf.text(
            `Each Light is ${Math.round(parsed[visMode] / dots.length) ? Number(Math.round(parsed[visMode] / dots.length)).toLocaleString() : "1,000"} Ancestors`,
            20,
            50
          );

      pdf.setFontSize(14);
      pdf.setTextColor(0); // ← reset to black
      pdf.text(
        parsed.reasoning ||`What you are seeing is a visual representation of abundance.

        This pool is generated using population-level reasoning.
        For the selected trait, we estimate how many ancestors in your lineage
        would statistically fall into the top tier of human expression.

        Each light represents a concentration of ancestors who embodied this trait
        at an exceptional level.

        This is not a literal family record.
        It is a symbolic field — designed to help the mind perceive abundance,
        support, and inherited capacity.`,
        20,
        60,
        { maxWidth: 170 }
      );

     

      pdf.addPage();

      // paint page black first
      // pdf.setFillColor(0, 0, 0);
      

      /* ---------- PAGE 2: VISUAL ---------- */
      const visualEl = document.getElementById("ancestralpool-visual");

      if (!visualEl) return;

      const canvas = await html2canvas(visualEl, {
        scale: 3,
        backgroundColor: "#000000",
        onclone: (doc) => {
          const clonedVisual = doc.getElementById("ancestralpool-visual"); 
          if (clonedVisual) { 
            // force black background and remove effects
            clonedVisual.style.boxShadow = "none"; // remove box shadow
            clonedVisual.style.border = "none"; // remove border
            clonedVisual.style.background = "#000000"; // ensure background is black    
          } 
        }
        // useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Largest possible square
      const size = Math.min(pageWidth, pageHeight);

      // Centered placement
      const x = (pageWidth - size) / 2;
      const y = (pageHeight - size) / 2;

      pdf.addImage(
        imgData,
        "PNG",
        x,
        y,
        size,
        size,
        undefined,
        "FAST"
      );

      pdf.save(
        `AncestralPool-${parsed?.traitRemix || "visual"}.pdf`
      );
}



// function sliderToCount(sliderValue) {
//   const minLog = Math.log10(MIN_THOUGHTS);
//   const maxLog = Math.log10(MAX_THOUGHTS);
//   const scale = sliderValue / 100;
//   const value = Math.pow(10, minLog + scale * (maxLog - minLog));
//   return Math.round(value);
// }

function countToSlider(count) {
  const minLog = Math.log10(MIN_THOUGHTS);
  const maxLog = Math.log10(MAX_THOUGHTS);
  return (
    ((Math.log10(count) - minLog) / (maxLog - minLog)) * 100
  );
}

// function formatBigNumber(n) {
//   return n.toLocaleString();
// }






  if (rawStored) {
    try {
      const parsedStored = JSON.parse(rawStored);
      initialDiary = parsedStored.text || "";
    } catch {
      initialDiary = rawStored;
    }
  }
  const [diaryAnswer, setDiaryAnswer] = useState(initialDiary);


// rotating daily questions
const questions = [
  "If all the ancestors in this pool took turns to say one thing to the group, what is one thing you think would be said?",
  "If an ancestor in this pool could whisper one blessing to you today, what would that be?",
  "Imagine your ancestors observing your day—what moment would they smile at, and why?",
  "If the strongest Intelligence in this pool sent you a message, what do you think it would be?",
];

const dailyQuestion =
  questions[dayjs().day() % questions.length]; // rotates daily


    let raw = responseRaw?.trim() ?? "";

    // Strip code fences
    raw = raw.replace(/```json\s*|```/g, "").trim();

    // Remove trailing commas
    raw = raw.replace(/,(\s*[}\]])/g, "$1");


  try {
    // console.log("Raw response from OpenAI:", responseRaw);

    parsed = JSON.parse(raw);
  } catch (e) {
    const match = raw.match(/\{[\s\S]*\}$/);
    // console.log("Attempting to parse JSON from responseRaw match:", match);
    // console.log("Full responseRaw for debugging:", responseRaw);
    // console.log("parsed so far:", parsed);
    if (match) {
      try {
        parsed = JSON.parse(match[0]);
      } catch {}
    }
  }

  if (parsed) {
    saveToHistory({ query: queryMeta.query, timestamp: Date.now(), result: parsed });
  }

  // Handle Offer action
function handleOffer() {
  // if (offerCount < 2) {
  //   setOfferCount(offerCount + 1);     // 1 → 2
  // } else if (offerCount === 2) {
    setOfferCount(1);                  // final increase
    setThankYou(true);                 // show ancestors message
  // }
}


  /** Determine how many dots to draw */
  // const dots = useMemo(() => {
  //   if (!parsed) return [];

  //   const value = parsed[visMode] || 0;
  //   // console.log("Value for visMode", visMode, "is", value);
  //   // console.log("Parsed object:", parsed);

  //   // Determine dot scaling
  //   let divisor = 1;
  //   if (value > 5000) divisor = 100;
  //   if (value > 50000) divisor = 10000;
  //   if (value > 500000) divisor = 10000;

  //   const dotCount = Math.max(1, Math.floor(value / divisor));

  //   return Array(dotCount).fill(0).map(() => ({
  //     top: Math.random() * 100 + "%",
  //     left: Math.random() * 100 + "%",
  //     size: Math.random() * 6 + 3,
  //     duration: 3 + Math.random() * 5,   // 3s – 8s
  //     delay: Math.random() * 6,          // staggered start
  //   }));
  // }, [parsed, visMode]);

const dots = useMemo(() => {
  const CENTER_DOT_PX = 10;
  const CANVAS_PX = 420; // same as your max-width
  const CENTER_CLEARANCE = (CENTER_DOT_PX / CANVAS_PX) * 100 * 1; // % space around center dot

  if (!parsed) return [];

  const value = parsed[visMode] || 0;

  let divisor = 100;
  if (value > 5000) divisor = 100;
  if (value > 50000) divisor = 100;
  if (value > 500000) divisor = 100;

  const dotCountWithoutCenter = Math.max(1, Math.floor(value / divisor));
  const dotCount = dotCountWithoutCenter + 1;

  const centerX = 50;
  const centerY = 50;

  // const ringSpacing = 6; // % distance between rings
  const maxRings = Math.ceil(Math.sqrt(dotCount));

  const dots = [];
  let placed = 0;

  // --- CENTER DOT ---
  dots.push({
    top: `${centerY}%`,
    left: `${centerX}%`,
    size: 3 ,
    // background: "rgba(241, 20, 20, 0.9)",
      isCenter: true,
    // duration: 4 + Math.random() * 4,
    // delay: Math.random() * 3,
  });
  placed = 1;

  // --- RINGS ---
  for (let ring = 1; ring < maxRings && placed < dotCount; ring++) {
    // const radius = ring * ringSpacing;
    // const radius = ringSpacing * ring * ring;
    // const baseSpacing = 3; // space between rings
    const baseRadius = baseSpacing * Math.pow(ring, 1.8);
    // const baseRadius = baseSpacing * ring * 1.6;
    // const baseRadius = baseSpacing * Math.sqrt(ring) * 4;



    const radius =
      ring === 1
        ? CENTER_CLEARANCE
        : baseRadius + CENTER_CLEARANCE;



    // number of dots grows with circumference (spiral-like logic)
    const dotsInRing = Math.max(
      9,
      Math.floor((2 * Math.PI * radius) / 2) //increase or reduce num of dots in circle
    );

    for (let i = 0; i < dotsInRing && placed < dotCount; i++) {
      const angle = (i / dotsInRing) * 2 * Math.PI;

      // shake/jitter
      const jitter = 0.15;    

      const perspective = perspectiveSelection

      const x =
        centerX +
        radius * Math.cos(angle) +
        (Math.random() - 0.5) * jitter;

      const y =
        centerY +
        radius * Math.sin(angle) * perspective +
        (Math.random() - 0.5) * jitter;

      // const size = Math.max(3, 6 - ring * 0.12);

      dots.push({
        top: `${y}%`,
        left: `${x}%`,
        size: 3 ,
        // duration: 3 + Math.random() * 5,
        // delay: Math.random() * 6,
      });

      placed++;
    }
    
  }

  return dots;
}, [parsed, visMode, baseSpacing, perspectiveSelection]);



const visualizationComplete =
  dots.length > 0 && visibleCount >= dots.length;


function speakEncouragement() {
  // if (!window.speechSynthesis) return;
  if (!voicesReadyRef.current) return;

  const line = `Each light here represents the arrival of ${Math.round(parsed[visMode] / dots.length)} Elite Ancestor. 
  They have all come for you, their descendant.
  They have come to share their knowledge and micro-thoughts with you.
  Feel them, mentally arriving and forming circles around you.
  Each of them can see your beliefs and thought patterns and are re-aligning them to their frequency.
  They are smiling and happy to help you re-align your energies, beliefs and micro-thoughts.
  Allow the energy of this field flow through your finger.
  Allow it realign your micro-thoughts.
  with each second that you hold, you are connecting deeper.
  Know that you are protected by countless generations who have come before you.

  `;
  const u = new SpeechSynthesisUtterance(line);
  u.voice = cachedVoiceRef.current; // required on mobile
  u.rate = 0.90;
  u.pitch = 1.0;
  u.volume = 1.0;
  u.lang = "en-US";
  // window.speechSynthesis.cancel();
  window.speechSynthesis.speak(u);
}



useEffect(() => {
  if (!dots.length || revealStarted.current) return;

  revealStarted.current = true;
  setVisibleCount(dots.length);

  let i = 0;

  // function revealNext() {
  //   i++;
  //   setVisibleCount(i);
  //   if (i < dots.length) {
  //     // speed up or slow down visualization here
  //     setTimeout(revealNext, 1);
  //   }
  // }

  // revealNext();
}, [dots]);

useEffect(() => {
  revealStarted.current = false;
}, [visMode]);



useEffect(() => {
  // Whenever resetTrigger changes, restart the visualization
  revealStarted.current = false;
  setVisibleCount(dots.length);
}, [resultsResetTrigger]);

useEffect(() => {
  return () => {
    clearInterval(holdIntervalRef.current);
  };
}, []);





// Build prompt for mini-traits -> generate short prayers for ancestors
// Build prompt for ancestral thoughts (Top 1%)
function buildAncestralThoughtsPrompt(parsedObj) {
  const trait = (parsedObj?.traitRemix ?? parsedObj?.trait ?? "").replace(/["']/g, "");
  const total = parsedObj?.totalAncestors ?? "";

  return `
You are modeling inner thoughts carried by exceptional human Intelligence after they have acheived ${trait}.

Context:
- Trait: ${trait}
- Pool size: ${total}
- Focus group: Top 1% of this pool

Task:
Generate a JSON object with a single key "thoughts".
The value must be an array of exactly 1 object.

Each object must have the shape:
{ "thought": "<short first-person internal thought, 8–16 words>" }

Rules (STRICT):
1. Output ONLY valid JSON. No commentary, no markdown.
2. Thoughts must be written in first person (e.g. "I am…", "I have…", "My mind is…").
3. Thoughts must be written like it has already happened.
4. Each thought represents a recurring inner belief or mental pattern caused by successful mastery of this trait.
5. Tone: victorious.
6. Do NOT mention ancestors, lineage, spirits, or metaphysics.
7. Make the words very simple not complicated words.

If you cannot generate appropriate thoughts, return:
{ "thoughts": [] }

Begin now and return ONLY the JSON object.
`;
}



  // Fetch mini-traits (only if parsed present and not already fetched)
  async function fetchMiniTraits(force = false) {
    if (!parsed) return;
    if (miniTraits && !force) return; // already have them
    setMiniError(null);
    setMiniLoading(true);
    // console.log("Fetching mini-traits for parsed result:", parsed);
    try {
      const prompt = buildAncestralThoughtsPrompt(parsed);
      const content = await queryOpenAI(prompt, queryMeta.model);
      // console.log("Mini-traits raw content:", content);
      // Strip code fences
      let safe = content
        .replace(/```json/i, "")
        .replace(/```/g, "")
        .trim();

      // parse JSON robustly
      let parsedMini = null;
      try {
        parsedMini = JSON.parse(safe);
        // console.log("Parsed mini-traits:", parsedMini);
      } catch (e) {
        const m = safe && safe.match(/\{[\s\S]*\}$/);
        if (m) {
          try { parsedMini = JSON.parse(m[0]); } catch {}
        }
      }

      // Accept prayers instead of miniTraits
    if (parsedMini && Array.isArray(parsedMini.thoughts)) {
        const sanitized = parsedMini.thoughts.map((it, idx) => ({
          id: idx,
          text: String(it.thought ?? "").trim(),
          frequency: countToSlider(1_000_000), // slider value
        }));
        setMiniTraits(sanitized);
      }
    else {
        try {
            const arr = JSON.parse(content);
            if (Array.isArray(arr)) {
            const sanitized = arr.slice(0, 8).map((it) => ({
                trait: "Prayer",
                why: String(it.prayer ?? it.text ?? "").trim(),
                score: null
            }));
            setMiniTraits(sanitized);
            } else {
            setMiniTraits([]);
            }
        } catch {
            setMiniTraits([]);
        }
    }

    } catch (err) {
      // console.error("Mini-traits generation error:", err);
      setMiniError(err.message || String(err));
    } finally {
      setMiniLoading(false);
    }
  }

  // Auto-fetch when parsed becomes available 
  // useEffect(() => {
  //   if (parsed && !miniTraits) {
  //     // console.log("Auto-fetching mini-traits for parsed result.");
  //     fetchMiniTraits(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [parsed]);

  // Scroll to results when loading completes
  useEffect(() => {
  if (!loading && parsed && !done) {
    const el = document.getElementById("results-section");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setDone(true);
  }
}, [loading, parsed, done]);


  async function saveJournalToFirestore() {
  if (!userId) {
    setShowSignInModal(true);
    return false;
  }

  const entry = {
    date: dayjs().format("YYYY-MM-DD"),
    question: dailyQuestion,
    answer: diaryAnswer.trim(),
    trait: parsed?.traitRemix || queryMeta?.query || "",
    poolSnapshot: parsed || {},
    createdAt: new Date().toISOString(),
  };

  try {
    const colRef = collection(db, "journals", userId, "entries");
    await addDoc(colRef, entry);
    return true;
  } catch (err) {
    console.error("Error saving journal:", err);
    return false
  }
}




  return (
  <div className="mt-4">

  

    {/* Loading */}
    {loading && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2000,
          backdropFilter: "blur(2px)",
          transition: "opacity 0.3s ease",
        }}
      >
        <div style={{ textAlign: "center", color: "#fff" }}>
          <Spinner animation="border" size="lg" />
          <p style={{ marginTop: "10px" }}>Creating Ancestral Energy Field...</p>
        </div>
      </div>
    )}

    {/* Error */}
    {error && (
      <Card
        body
        className="border-danger text-danger"
        style={{
          borderRadius: "16px",
          padding: "18px",
          background: "#fff5f5",
          border: "1px solid #ffdddd",
        }}
      >
        Error: {String(error)}
      </Card>
    )}

    {/* Success */}
    {!loading && parsed && (
      <>
        <Card id="results-section"
          style={{
            padding: "0",
            borderRadius: "20px",
            border: "1px solid rgba(0,0,0,0.05)",
            boxShadow: "0 8px 26px rgba(0,0,0,0.07)",
            overflow: "hidden",
            marginBottom: "44px",
          }}
        >
          <Card.Body  style={{ padding: "28px" }}>

            {/* Header */}
            <div style={{ textAlign: "center", marginBottom: "22px" }}>

            <p
            style={{
                fontWeight: 450,
                fontSize: "14px",
                lineHeight: "1.2",
                marginBottom: "8px",
                color: "#4d4c4cff",
                letterSpacing: "-0.5px",
            }}
            >
               Your Ancestors Who Possessed:
            </p>
              

            <p
            style={{
                fontWeight: 500,
                fontSize: "22px",
                lineHeight: "1.2",
                marginBottom: "8px",
                color: "#111",
                letterSpacing: "-0.5px",
            }}
            >
               {parsed.traitRemix
                ? parsed.traitRemix
                    .split(" ")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")
                : ""} 
            </p>

            </div>


            {/* Mini Nav Tabs */}
           
            {/* Bootstrap Nav Tabs */}
            <Nav variant="underline" className="mb-3" justify>
                <Nav.Item>
                <Nav.Link
                    eventKey="visual"
                    active={sectionMode === "visual"}
                    onClick={() => {
                      setSectionMode("visual");
                      }}
                    style={{ color: sectionMode === "visual" ? undefined : "#888" }}
                >
                    Ancestral Pool
                </Nav.Link>
                </Nav.Item>

                <Nav.Item style={{ position: "relative" }}>
                  <Nav.Link
                    eventKey="reasoning"
                    active={sectionMode === "reasoning"}
                    onClick={() => {
                      setSectionMode("reasoning");
                      // Mark About Result as opened
                      if (!aboutClicked) {
                        setAboutClicked(true);
                        localStorage.setItem("aboutResultOpened", "true");
                      }
                      mixpanel.track('explanation', { 
                        signedIn: userId ? 'yes' : 'no',
                        energy: parsed?.traitRemix || queryMeta?.query || "",
                      });
                    }}
                    style={{ color: sectionMode === "reasoning" ? undefined : "#888" }}
                  >
                    About Pool
                    {!aboutClicked && (
                      <Badge
                        bg="success"
                        pill
                        style={{
                          position: "absolute",
                          top: "0px",
                          left: "3px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "18px",
                          height: "18px",
                          fontSize: "10px",
                        }}
                      > 1
                      </Badge>
                    )}
                  </Nav.Link>
                </Nav.Item>
                
            </Nav>


            {/* Section Switcher */}
            {sectionMode === "visual" && (
            <>
                        {/* Visualization Canvas — Unchanged */}
                        <div
                        id="ancestralpool-visual"
                        style={{
                            marginTop: "20px",
                            // height: "300px",
                            width: "100%",
                            aspectRatio: "1 / 1",   // 👈 forces square
                            maxWidth: "420px",      // 👈 optional: prevents it from getting huge on desktop
                            marginLeft: "auto",
                            marginRight: "auto",
                            background: "radial-gradient(circle at center, #0b0f0b, #000000)",
                            borderRadius: "12px",
                            position: "relative",
                            overflow: "hidden",
                            boxShadow: "0 0 25px rgba(0,255,120,0.2) inset",
                        }}
                        >

                        {/* Center Hold Area */}
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            width: "80px",
                            height: "80px",
                            transform: "translate(-50%, -50%)",
                            borderRadius: "50%",
                            cursor: "pointer",
                            zIndex: 5,
                          }}
                          onMouseDown={startHold}
                          onMouseUp={endHold}
                          onMouseLeave={endHold}
                          onTouchStart={startHold}
                          onTouchEnd={endHold}
                        />

                        {dots.slice(0, visibleCount).map((dot, i) => (
                            <div
                              key={`${visMode}-${i}`}
                              className={dot.isCenter ? "dot center-dot" : "dot"}
                              style={{
                                position: "absolute",
                                top: dot.top,
                                left: dot.left,
                                width: dot.size + "px",
                                height: dot.size + "px",
                                // background: "rgba(248, 248, 248, 0.9)",
                                borderRadius: "50%",
                                // animation: `pulseDot ${dot.duration}s ease-in-out infinite`,
                                // animationDelay: `${dot.delay}s`,
                                // willChange: "opacity, transform",
                                // boxShadow: "0 0 8px rgba(209, 210, 210, 0.8), 0 0 18px rgba(147, 171, 161, 0.4), 0 0 25px rgba(245, 255, 240, 0.2)",
                                transform: dot.isCenter && isHolding ? "scale(1.4)" : undefined,
                                transition: "transform 0.2s ease",
                                filter: dot.isCenter && isHolding
                                  ? "drop-shadow(0 0 12px rgba(255,255,255,0.8))"
                                  : undefined,
                                
                                // background: dot.isCenter
                                // ? "rgba(241, 20, 20, 0.95)" // 🔴 red center dot
                                // : "rgba(248, 248, 248, 0.9)",
                              }}
                            />
                        ))}
                        </div>

                         {/* Glow Explanation */}
                        {/* <div
                        className="text-center text-muted mt-2"
                        style={{ fontSize: "12px", marginBottom: "20px" }}
                        >
                        {parsed[visMode] > dots.length && (
                            <>Each Light is {Math.round(parsed[visMode] / dots.length) ? Number(Math.round(parsed[visMode] / dots.length)).toLocaleString() : "—"} Ancestors</>
                        )}
                        {parsed[visMode] <= dots.length && (<> 1 Light is 1 Ancestor</>)}
                        </div> */}

                        {/* {!visualizationComplete && (
                          <div
                            style={{
                              marginTop: "6px",
                              fontSize: "11px",
                              color: "#888",
                              textAlign: "center",
                            }}
                          >
                            Completing the pool unlocks download
                          </div>
                        )} */}


                    <div style={{ textAlign: "center", marginTop: "18px" }}>
                      <Button
                        variant="outline-dark"
                        disabled={!visualizationComplete}
                        style={{
                          borderRadius: "20px",
                          padding: "8px 18px",
                          fontWeight: 500,
                          fontSize: "14px",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                          opacity: visualizationComplete ? 1 : 0.5,
                          cursor: visualizationComplete ? "pointer" : "not-allowed",
                        }}
                        onClick={handlePrintAncestralPool}
                      >
                        <Download size={14} />
                        Download
                      </Button>
                    </div>


                         {/* --- DAILY ANCESTRAL JOURNAL (REDESIGNED) --- */}
    <div
      style={{
        marginTop: "40px",
        padding: "24px",
        background: "#ffffff",
        borderRadius: "16px",
        border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
        maxWidth: "600px",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* HEADER: DATE & TITLE */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <h3 style={{ fontSize: "16px", fontWeight: 600, color: "#222", margin: 0 }}>
          Ancestral Journal
        </h3>
        <span
          style={{
            fontSize: "12px",
            background: "#f2f2f2",
            padding: "4px 12px",
            borderRadius: "12px",
            color: "#666",
            fontWeight: 500,
          }}
        >
          {dayjs().format("MMM D, YYYY")}
        </span>
      </div>

      {/* RULE / GUIDANCE */}
      {/* <div
        style={{
          fontSize: "13px",
          color: "#555",
          background: "#f9f9f9",
          padding: "10px 14px",
          borderRadius: "10px",
          borderLeft: "4px solid #0dc300",
          marginBottom: "12px",
        }}
      >
        <strong>Rule:</strong> You don’t need to change anything, just notice.
      </div> */}

      {/* QUESTION */}
      {/* <p
        style={{
          fontSize: "14px",
          color: "#333",
          lineHeight: "1.6",
          marginBottom: "14px",
          fontWeight: 500,
        }}
      >
        As your ancestors surround you,  
        notice how your <strong>micro-beliefs naturally self-correct</strong>.  
        In what direction are your micro-beliefs guiding you now?
      </p> */}

        <p
          style={{
            fontSize: "14px",
            color: "#333",
            lineHeight: "1.6",
            marginBottom: "14px",
            fontWeight: 500,
          }}
        >
          What are your Ancestors telling you right now?
        </p>

        {/* TEXT AREA */}
        <textarea
          value={diaryAnswer}
          onChange={(e) => setDiaryAnswer(e.target.value)}
          placeholder="Write your reflection here..."
          style={{
            width: "100%",
            minHeight: "140px",
            borderRadius: "12px",
            border: "1px solid #ddd",
            padding: "14px",
            fontSize: "14px",
            outline: "none",
            resize: "vertical",
            marginBottom: "16px",
            background: "#fcfcfc",
            transition: "border-color 0.2s",
          }}
          onFocus={(e) => (e.target.style.borderColor = "#0dc300")}
          onBlur={(e) => (e.target.style.borderColor = "#ddd")}
        />

        {/* SAVE BUTTON */}
        <div style={{ textAlign: "right" }}>
          <Button
            onClick={async () => {
              localStorage.setItem(
                todayKey,
                JSON.stringify({
                  text: diaryAnswer,
                  question: dailyQuestion,
                })
              );
              mixpanel.track("saveJournal", {
                signedIn: userId ? "yes" : "no",
                energy: parsed?.traitRemix || queryMeta?.query || "",
                diaryAnswer: diaryAnswer.trim(),
                diaryQuestion: dailyQuestion,
              });
              const saved = await saveJournalToFirestore();
              if (saved) {
                setShowSavedModal(true);
              }
            }}
            disabled={!diaryAnswer.trim()}
            style={{
              padding: "10px 20px",
              borderRadius: "12px",
              background: "linear-gradient(120deg, #0dc300, #065600)",
              border: "none",
              fontWeight: 600,
              fontSize: "14px",
              color: "#fff",
              cursor: diaryAnswer.trim() ? "pointer" : "not-allowed",
              transition: "transform 0.1s, box-shadow 0.2s",
            }}
            onMouseOver={(e) => {
              if (diaryAnswer.trim()) e.currentTarget.style.transform = "scale(1.03)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            Save
          </Button>
        </div>
      </div>
                {/* Energy Charge Meter */}
              {/* Energy Charge Meter */}

            {/* <div className="energy-meter-wrapper" style={{ paddingBottom: "4px", marginTop: "24px" }}>
                <div className="energy-meter-label">
                    Hold the center light for one minutes to fully charge.
                </div>

                <div
                  className="energy-meter"
                  role="slider"
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-valuenow={energyCharge}
                  tabIndex={0}
                  onClick={(e) => {
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = e.clientX - rect.left;
                    const percent = (x / rect.width) * 100;

                    // snap to 0,25,50,75,100
                    const snapped =
                      percent < 12.5 ? 0 :
                      percent < 37.5 ? 25 :
                      percent < 62.5 ? 50 :
                      percent < 87.5 ? 75 :
                      100;

                    setEnergyCharge(snapped);
                  }}
                >
                  <div
                    className="energy-fill"
                    style={{ width: `${energyCharge}%` }}
                  />
                  <div className="energy-glow" />
                </div>
              </div>  */}

              <div
                style={{
                  marginTop: "12px",
                  textAlign: "center",
                  fontSize: "33px",
                  color: "#666",
                  letterSpacing: "0.02em",
                }}
              >
                {/* {holdTimeMs > 0 ? (
                  <>{(holdTimeMs / 1000).toFixed(1)} Seconds</>
                ) : (
                  <>Press and hold the center light</>
                )} */}
                {/* {energyCharge < 100 ? (
                    <>
                      {Math.max(
                        0,
                        ((HOLD_FULL_MS - holdTimeMs) / 1000).toFixed(0)
                      )} seconds to full charge
                    </>
                  ) : (
                    <>Energy fully charged</>
                  )} */}

              </div>

              
  
             </>
            )}

             {/* Reasoning section */}
            {sectionMode === "reasoning" && (
                <div style={{ marginTop: "22px" }}>

                        <p
                        style={{
                            whiteSpace: "pre-wrap",
                            fontSize: "14px",
                            color: "#444",
                            lineHeight: "1.45",
                        }}
                        >
                        {parsed.reasoning}
                        </p>

                        {/* <p
                        className="text-muted"
                        style={{
                            fontSize: "13px",
                            marginTop: "10px",
                        }}
                        >
                        Total Ancestors Considered:{" "}
                        {parsed.totalAncestors?.toLocaleString()}
                        </p> */}

                        </div>
            )}

          </Card.Body>
        </Card>
      </>
    )}

    {/* Raw output fallback */}
    {!loading && !parsed && responseRaw && (
      <Card className="mt-2" style={{ borderRadius: "16px" }}>
        <Card.Body>
          <pre style={{ maxHeight: 260, overflow: "auto" }}>{responseRaw}</pre>
        </Card.Body>
      </Card>
    )}


    <Modal show={showSavedModal} onHide={() => setShowSavedModal(false)} centered>
  <Modal.Body
    style={{
      padding: "28px",
      textAlign: "center",
      fontSize: "16px",
      fontWeight: 500,
    }}
  >
    Your journal entry has been saved!
    <div style={{ fontSize: "14px", marginTop: "10px", color: "#666" }}>
      You'll get a different question everyday.
    </div>

    <Button
      onClick={() => setShowSavedModal(false)}
      style={{
        marginTop: "20px",
        borderRadius: "10px",
        padding: "8px 18px",
        background: "#111",
        border: "none",
        fontWeight: 600,
      }}
    >
      Okay
    </Button>
  </Modal.Body>
</Modal>


      <Modal
        show={showSignInModal}
        onHide={() => setShowSignInModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Sign in Required</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <p>Please sign in with Google to create a pool.</p>
          <Button
            onClick={async () => {
              await signInWithGoogle();
              setShowSignInModal(false);
            }}
           style={{ 
              background: "linear-gradient(120deg, #0dc300ff, #065600ff)",
              color: "white",
              border: "none" }}
          >
            Sign in with Google
          </Button>
        </Modal.Body>
      </Modal>

  </div>
);

}
